// extracted by mini-css-extract-plugin
export default {"title":"pkEo0","inner":"MaZh0","answers":"yJnmP","answer":"izjb6","answerMenu":"WhGZS","divider":"QuKDy","addBtn":"sUcOU"};